import styled from "styled-components";

export const Sessao = styled.div`
  padding: 0 30px;
  width: 100%;
  margin-bottom: 120px;
  @media screen and (max-width: 414px) {
    padding: 0 24px;
  }
`;
export const Container = styled.div`
  max-width: 1040px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;

export const Wrapper = styled.div`
  display: grid;
  gap: 20px;
  align-items: flex-start;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
`;
